import { render, staticRenderFns } from "./AIGeneratedPickAnswerContent.vue?vue&type=template&id=36c86b3e&"
import script from "./AIGeneratedPickAnswerContent.vue?vue&type=script&lang=js&"
export * from "./AIGeneratedPickAnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./AIGeneratedPickAnswerContent.vue?vue&type=style&index=0&id=36c86b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports